import axios from 'axios';
import React, { useEffect, useState } from 'react';
import {
  FETCH_CASHBACK_LIST,
  GET_ACTIVE_STORES,
  SAVE_CASHBACKAPI_ENABLED
} from '../routes';
import moment from 'moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';

const ActiveStores = () => {
  const [fetching, setFetching] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [stores, setActiveStores] = useState([]);
  const [storeCount, setStoresCount] = useState(0);
  const [cashbackCampaigns, setCashbackCampaigns] = useState([]);

  // Search
  const [search, setSearch] = useState('');

  const loader = () => {
    return (
      <tr>
        <td colSpan={11} className="text-center">
          <div className="loader">
            <svg viewBox="0 0 80 80">
              <circle id="test" cx="40" cy="40" r="32"></circle>
            </svg>
          </div>
        </td>
      </tr>
    );
  };

  // Get active stores - API only once
  const getActiveStores = async () => {
    setFetching(true);

    try {
      const result = await axios.post(GET_ACTIVE_STORES);

      setActiveStores(result);
      setStoresCount(result?.data?.total_active || 0);
    } catch (error) {
      console.error(error);
    } finally {
      setFetching(false);
    }
  };

  const formatDateTime = (value) => {
    return moment(value).format('Do MMM YYYY');
  };

  const cashbackCampaign = (
    <Tooltip id="cashbackCampaign">
      <strong>Reward Campaign</strong>
    </Tooltip>
  );

  const getCashbackCampaign = async (shop_id) => {
    setProcessing(true);

    try {
      const result = await axios.post(FETCH_CASHBACK_LIST, {
        shop_id: shop_id
      });

      setCashbackCampaigns(result);
    } catch (error) {
      console.error(error);
    } finally {
      setProcessing(false);
    }
  };

  const showCashbackCampaign = (shop_id) => {
    getCashbackCampaign(shop_id);
  };

  // Is Cashbackapi Enabled
  const toggleIsCashbackapiEnabledAction = async (event, shop_id) => {
    try {
      const result = await axios.post(SAVE_CASHBACKAPI_ENABLED, {
        shop_id: shop_id,
        is_cashbackapi_enabled: event.target.checked
      });

      if (result.data.success) {
        toast.success(
          event.target.checked ? 'Enabled' : 'Disabled'
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  /*
   * FRONTEND SEARCH ONLY
   * No API call on search.
   */
  const filteredStores =
    stores?.data?.shops?.filter((store) => {
      const searchValue = search
        .toLowerCase()
        .trim()
        .replace(/^https?:\/\//, '')
        .replace(/^www\./, '');

      if (!searchValue) {
        return true;
      }

      const shopName = (store?.shop || '')
        .toLowerCase()
        .trim()
        .replace(/^https?:\/\//, '')
        .replace(/^www\./, '');

      const shopEmail = (
        store?.shop_email || ''
      ).toLowerCase();

      const customerEmail = (
        store?.shop_customer_email || ''
      ).toLowerCase();

      const phone = (
        store?.shop_phone || ''
      ).toLowerCase();

      const country = (
        store?.shop_country_name || ''
      ).toLowerCase();

      const planName = (
        store?.plan?.plan_name || ''
      ).toLowerCase();

      const install = (
        formatDateTime(store?.created_at) || ''
      ).toLowerCase();

      const rewardType =
      store?.reward_type == 0
        ? 'cashback system'
        : 'points system';

      return (
        shopName.includes(searchValue) ||
        shopEmail.includes(searchValue) ||
        customerEmail.includes(searchValue) ||
        phone.includes(searchValue) ||
        country.includes(searchValue) ||
        planName.includes(searchValue) || install.includes(searchValue) || rewardType.includes(searchValue)
      );
    }) || [];

    const cashbackData =
      cashbackCampaigns?.data?.data || [];

    const tierTypeData =
      cashbackCampaigns?.data?.tier_types || [];

  const cashbackCampaignHTML =
  cashbackData.length || tierTypeData.length ? (
    <>

      {/* ================= TIER PROGRAMS ================= */}

      {tierTypeData.map((value) => (
        <tr key={`tier-${value.id}`}>

          {/* Tier Name */}
          <td>
            <span
              style={{
                color: '#4F46E5',
                fontWeight: '600'
              }}
            >
              {value.title || 'Tier Program'}
            </span>
          </td>

          {/* Type */}
          <td>
            <span
              style={{
                color: '#4F46E5',
                fontWeight: '600'
              }}
            >
              Tier Program
            </span>
          </td>

          {/* Status */}
          <td>
            <span
              style={{
                color:
                  cashbackCampaigns?.data?.tier_status
                    ? '#04c504'
                    : 'red',
                fontWeight: '600'
              }}
            >
              {cashbackCampaigns?.data?.tier_status
                ? 'Active'
                : 'Inactive'}
            </span>
          </td>

          {/* Cashback Type */}
          <td>
            {Number(value.cashback_type) === 1
              ? 'Percentage'
              : Number(value.cashback_type) === 2
              ? 'Amount'
              : '--'}
          </td>

          {/* Cashback Value */}
          <td>
            {value.cashback_value ?? '--'}
          </td>

          {/* Eligible Purchase */}
          <td>
            {value.eligible_purchase_amount ??
              '--'}
          </td>

          {/* Max Cashback */}
          <td>
            {value.max_cashback_amt ?? '--'}
          </td>

          {/* Created Date */}
          <td>
            {value.created_at
              ? formatDateTime(
                  value.created_at
                )
              : '--'}
          </td>

          {/* Updated Date */}
          <td>
            {value.updated_at
              ? formatDateTime(
                  value.updated_at
                )
              : '--'}
          </td>

        </tr>
      ))}

      {/* ================= CASHBACK CAMPAIGNS ================= */}

      {cashbackData.map((value) => (
        <tr key={`cashback-${value.id}`}>

          {/* Campaign Name */}
          <td>
            {value.name || '--'}
          </td>

          {/* Campaign Type */}
          <td>
            {value.type == '1' && 'Facebook Share'}
            {value.type == '2' && 'Instagram Follow'}
            {value.type == '3' && 'Twitter Retweet'}
            {value.type == '4' && 'Total Purchase'}
            {value.type == '5' && 'Customer Group'}
            {value.type == '6' && 'Create Account'}
            {value.type == '7' && 'Shipping Charges'}
            {value.type == '8' && 'Referral'}
            {value.type == '9' && 'LinkedIn Share'}
            {value.type == '0' &&
              'Products OR Collections'}
            {value.type == '10' &&
              'Use It or Lose It'}
            {value.type == '11' &&
              'Judge.me review'}
            {value.type == '12' &&
              'Store Credit'}
            {value.type == '13' &&
              'Coupons Reward'}
            {value.type == '14' &&
              'Birthday Coupon'}
          </td>

          {/* Status */}
          <td>
            {value.active ? (
              <span
                style={{
                  color: '#04c504',
                  fontWeight: '600'
                }}
              >
                Active
              </span>
            ) : (
              <span
                style={{
                  color: 'red'
                }}
              >
                Inactive
              </span>
            )}
          </td>

          {/* Apply Type */}
          <td>
            {value.apply_type || '--'}
          </td>

          {/* Apply Type Value */}
          <td>
            {value.apply_type_value || '--'}
          </td>

          {/* Apply On */}
          <td>
            {value.apply_on
              ? value.apply_on
              : '--'}
          </td>

          {/* Max Cashback */}
          <td>
            {value.max_cashback_amount
              ? value.max_cashback_amount
              : '--'}
          </td>

          {/* Start Date */}
          <td>
            {value.campaign_start_time
              ? formatDateTime(
                  value.campaign_start_time
                )
              : '--'}
          </td>

          {/* End Date */}
          <td>
            {value.campaign_end_time
              ? formatDateTime(
                  value.campaign_end_time
                )
              : '--'}
          </td>

        </tr>
      ))}

    </>
  ) : (
    <tr>
      <td
        colSpan={9}
        className="text-center"
      >
        No data found!
      </td>
    </tr>
  );

  const generateRawHtml = filteredStores.length
    ? filteredStores.map((store) => {
        // IMPORTANT:
        // Every store gets unique modal ID
        const modalId = `cashbackCampaign-${store.id}`;

        return (
          <tr key={store.id}>
            <td align="center"  data-bs-toggle="modal"
                  data-bs-target={`#${modalId}`}
                  onClick={() =>
                    showCashbackCampaign(store.id)
                  }
                  style={{ cursor: 'pointer' }}>
              <OverlayTrigger
                placement="bottom"
                overlay={cashbackCampaign}
              >
                <i
                  className="fa-solid fa-list"
                
                ></i>
              </OverlayTrigger>

              {/* Cashback Modal */}
              <div
                className="modal fade"
                id={modalId}
                aria-hidden="true"
              >
                <div className="modal-dialog modal-xl">
                  <div className="modal-content">

                    <div className="modal-header">
                      <h5 className="modal-title">
                        Reward Campaigns
                      </h5>

                      <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                      ></button>
                    </div>

                    <div className="modal-body">
                      <div className="box mt-2">
                        <div className="box-body">

                          <div className="table-responsive-lg">
                            <table className="table sub-table table-striped table-bordered">

                              <thead>
                                <tr>
                                  <th>
                                    Campaign Name
                                  </th>

                                  <th>
                                    Campaign Type
                                  </th>

                                  <th>
                                    Status
                                  </th>

                                  <th>
                                    Apply Type
                                  </th>

                                  <th>
                                    Apply Type Value
                                  </th>

                                  <th>
                                    Apply On
                                  </th>

                                  <th>
                                    Max Cashback Amount
                                  </th>

                                  <th>
                                    Campaign Start Date
                                  </th>

                                  <th>
                                    Campaign End Date
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {processing
                                  ? loader()
                                  : cashbackCampaignHTML}
                              </tbody>

                            </table>
                          </div>

                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </td>

            <td>
              https://{store.shop}
            </td>

            <td>
              <span
                style={{
                  color: '#52d952',
                  fontWeight: '600'
                }}
              >
                Active
              </span>
            </td>

            {/* Reward Type */}
            <td align="center">
              <span
                style={{
                  color: store?.reward_type == 0 ? '#059669' : '#4F46E5',
                  fontWeight: '600'
                }}
              >
                {store?.reward_type == 0
                  ? 'Cashback System'
                  : 'Points System'}
              </span>
            </td>

            <td align="center">
                {store?.smtp ? 'Yes' : '-'}
            </td>

            <td>
              {store?.plan?.plan_name
                ? store.plan.plan_name
                : 'N/A'}
            </td>

            <td>
              <div style={{ whiteSpace: 'nowrap' }}>
                {store.shop_email || '-'}
              </div>

              {store.shop_customer_email !==
                store.shop_email && (
                <div style={{ whiteSpace: 'nowrap' }}>
                  {store.shop_customer_email || '-'}
                </div>
              )}
            </td>

            <td>
              {store.shop_phone
                ? store.shop_phone
                : '-'}
            </td>

            <td>
              {formatDateTime(store.created_at)}
            </td>

            <td>
              <div style={{ whiteSpace: 'nowrap' }}>
                {store.plan_start_at
                  ? formatDateTime(store.plan_start_at)
                  : '-'}
              </div>

              <div style={{ whiteSpace: 'nowrap' }}>
                {store.plan_end_at
                  ? formatDateTime(store.plan_end_at)
                  : '-'}
              </div>
            </td>

            <td>
              {store.shop_country_name
                ? store.shop_country_name
                : 'N/A'}
            </td>
          </tr>
        );
      })
    : (
        <tr>
          <td colSpan={11} className="text-center">
            No data found!
          </td>
        </tr>
      );

  // Initial API call
  useEffect(() => {
    getActiveStores();
  }, []);

  // Ctrl + F / Cmd + F
  useEffect(() => {
    const handleCtrlF = (event) => {
      if (
        (event.ctrlKey || event.metaKey) &&
        event.key.toLowerCase() === 'f'
      ) {
        event.preventDefault();

        const searchInput =
          document.getElementById('store-search');

        if (searchInput) {
          searchInput.focus();
          searchInput.select();
        }
      }
    };

    document.addEventListener(
      'keydown',
      handleCtrlF
    );

    return () => {
      document.removeEventListener(
        'keydown',
        handleCtrlF
      );
    };
  }, []);

  return (
    <div className="container">

      <div className="row mt-3">

        <div className="col-lg-12">

          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">

            {/* Left */}
            <h4 className="mb-0">
              Active Stores{' '}
              {storeCount > 0 && (
                <span
                  style={{
                    color: 'rgb(98, 234, 141)'
                  }}
                >
                  ({storeCount})
                </span>
              )}
            </h4>

            {/* Right */}
            <div
              className="d-flex align-items-center"
              style={{ gap: '10px' }}
            >

              {search && (
                <small
                  className="text-muted"
                  style={{
                    whiteSpace: 'nowrap'
                  }}
                >
                  Showing {filteredStores.length} of{' '}
                  {stores?.data?.shops?.length || 0}{' '}
                  stores
                </small>
              )}

              <Form.Control
                type="text"
                id="store-search"
                placeholder="Search anything..."
                value={search}
                onChange={(e) =>
                  setSearch(e.target.value)
                }
                style={{
                  width: '350px'
                }}
              />

            </div>

          </div>

          {/* Main Box */}
          <div
            className="box mt-2"
            style={{
              height: 'calc(100vh - 180px)',
              overflowY: 'auto'
            }}
          >

            <div className="box-body">

              <div className="table-responsive-lg">

                <table className="table sub-table table-striped table-bordered">

                  <thead
                    style={{
                      position: 'sticky',
                      top: 0,
                      zIndex: 10,
                      background: '#fff'
                    }}
                  >
                    <tr>
                      <th>Action</th>
                      <th>Store Name</th>
                      <th>Status</th>
                      <th>Reward Type</th>
                      <th>SMTP</th>
                      <th>Plan Name</th>
                      <th>Email</th>
                      <th>Phone</th>
                      <th>Installation Date</th>
                      <th>Plan Start/End Date</th>
                      <th>Country</th>
                    </tr>
                  </thead>

                  <tbody>
                    {fetching
                      ? loader()
                      : generateRawHtml}
                  </tbody>

                </table>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
};

export default ActiveStores;